import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import imgTemp from "../../assets/landers_temp3.jpeg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import useReactGASend from "../../hooks/useReactGASend";
import { GiCheckMark } from "react-icons/gi";
import React from "react";


const common = [
  {
    title: "자동 직관 기록 방법",
    content:
      "랜더스 APP을 통해 예매한 티켓은 입장 검표 시 예매자의 APP 계정으로 자동 직관 기록 처리됩니다. \n\n - 랜더스 APP 예매 건에 한 해 적용됩니다. \n- 선물 받은 티켓의 경우 입장 검표 시 예매자의 APP 계정으로 자동 직관 기록됩니다. \n- 직관 기록은 반드시 경기 당일 기록 여부 확인이 필요합니다. \n- 자동 직관 기록 불가 시 티켓을 사용하여 수기로 기록/이용하여 주시기 바랍니다.",
    reference: "",
  },
  {
    title: "수동 직관 기록 방법",
    content:
      "자동 직관 기록이 불가한 경우 티켓을 사용하여 수기로 직관 기록 처리가 가능합니다. \n\n [ICON:check] 수동 직관 기록 방법 \n- 랜더스 APP → MY → 직관 기록 → 수동 직관 기록 → 티켓 QR코드 or 티켓 번호 입력 \n *가능 시간 : 경기 시작 3시간 전~경기 종료 시 \n\n - 선물 받은 티켓, 현장 예매 건은 수동 직관 기록만 가능합니다. \n- 직관 기록은 경기별로 계정당 1회 가능합니다.\n - 수동 직관 기록이 불가한 경우 경기 당일 랜더스센터를 방문하여 주시면 직원의 도움을 받으실 수 있습니다. \n[SPACE](랜더스센터 위치 : 경기장 내부 1층 의무실 앞)",
    reference: "",
  },
  {
    title: "자동 직관 기록이 등록 되지 않았어요.",
    content:
      "자동 직관 기록은 랜더스 APP에서 예매한 티켓에 한 해 티켓 검표 시 예매자의 계정으로 자동 적립됩니다. \n\n 선물 받은 티켓 및 현장 예매 티켓은 티켓 QR코드 및 티켓 번호를 사용하여 직관 기록이 가능합니다. \n\n [ICON:check]수동 직관 기록 방법 \n- 랜더스 APP → MY → 직관 기록 → 수동 직관 기록 → 티켓 QR코드 or 티켓 번호 입력 \n*가능 시간 : 경기 시작 3시간 전~경기 종료 시\n\n- 직관 기록은 경기 당일에만 가능합니다.\n- 직관 기록은 경기별로 계정당 1회 가능합니다.\n- 수동 직관 기록 등록이 불가한 경우 경기 당일 랜더스센터를 방문하여 주시면 직원의 도움을 받으실 수 있습니다.\n[SPACE](랜더스센터 위치 : 경기장 내부 1층 의무실 앞)",
    reference: "",
  }
];

const ICON_MAP = {
  check: <GiCheckMark className="inline-block mr-1"/>
}

const formatText = (text) => {
  return text.split("\n").map((line, index) => {
    const elements = [];

    let rest = line;

    // 1. 앞에 [SPACE]가 몇 개 있는지 계산
    const spaceMatches = rest.match(/^(\[SPACE])+/);
    if (spaceMatches) {
      const count = spaceMatches[0].match(/\[SPACE\]/g).length;
      for (let i = 0; i < count; i++) {
        elements.push(<span key={`space-${i}`} className="pl-2" />);
      }
      rest = rest.replace(/^(\[SPACE\])+/,"").trim();
    }

    // 2. 아이콘 처리
    const iconMatch = rest.match(/\[ICON:(.+?)\]/);
    if (iconMatch) {
      const iconKey = iconMatch[1];
      elements.push(
        <span key="icon" className="inline-flex items-baseline">
          {ICON_MAP[iconKey]}
        </span>
      );
      rest = rest.replace(iconMatch[0], "").trim();
    }

    // 3. 텍스트
    elements.push(<span key="text">{rest}</span>);

    return (
      <div key={index} className="flex items-center">
        {elements}
        {index < text.split("\n").length - 1 && <br />}
      </div>
    );
  });
};

export const AccordionItemComponent = ({
  item,
  index,
}) => {
  return (
    <AccordionItem
      key={index}
      itemKey={index}
      className="mb-2"
      header={({state}) => 
        <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
          <span
            className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
          >
            Q
          </span>
          {item.title}
        </div>
      }
    >
      {({state}) => 
        <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
          <div className="font-medium text-gray-950">{formatText(item.content)}</div>
        </div>
      } 
    </AccordionItem>
  );
}


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

const CheckinPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };


  return (
    <section className="p-hasHeader">
      <Header title="직관기록" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950">
        <span>SSG랜더스 APP 회원일 경우 경기 관람 후 티켓 인증을 통해 직관 기록을 남기실 수 있습니다.</span>
        <ul className="list-disc pl-8">
          <li>직관 기록은 경기당 1회 가능합니다.</li>
        </ul>
        <div className="pt-5">
          <div>[직관 기록 이용 방법]</div>
          <div>1{")"} SSG랜더스 APP 설치 후 회원가입</div>
          <div>2{")"} APP {">"} MY {">"} 직관 기록 메뉴 확인</div>
          <div>3{")"} 당일 경기 티켓 인증 후 직관 기록 등록</div>
          <div className="pt-5">자세한 사항은 랜더스 APP을 확인해 주세요.</div>
        </div>
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:032-455-2600"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("체크인_전화상담")}
        />
      </div>
    </section>
  );
};

export default CheckinPage;
